export default __webpack_public_path__ + "static/media/logoCagette.ce8496f2.png";